export const POLARITY_TABS = {
    TEXTS: "Texts",
    EMAILS: "Emails",
};

export const POLARITY_TABLE_COLUMNS = [
    { id: "conversationdate", isSortable: false, label: "Conversation Date" },
    { id: "verypositive", isSortable: false, label: "Very Positive" },
    { id: "positive", isSortable: false, label: "Positive" },
    { id: "neutral", isSortable: false, label: "Neutral" },
    { id: "negative", isSortable: false, label: "Negative" },
    { id: "verynegative", isSortable: false, label: "Very Negative" },
    { id: "total", isSortable: false, label: "Total" },
];

export const POLARITY_TABLE_COLUMNS_KEYS = {
    CONVERSATIONDATE: "conversationdate",
    VERYPOSITIVE: "verypositive",
    POSITIVE: "positive",
    NEUTRAL: "neutral",
    NEGATIVE: "negative",
    VERYNEGATIVE: "verynegative",
    TOTAL: "total",
};

export const POLARITY_ERRORS = {
    FETCH_POLARITY_DATA_ERROR: "Error fetching polarity data:",
}

export const formatDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
        const pad = (n, z = 2) => String(n).padStart(z, "0");
        return (
            value.getFullYear() + "-" +
            pad(value.getMonth() + 1) + "-" +
            pad(value.getDate()) + " " +
            pad(value.getHours()) + ":" +
            pad(value.getMinutes()) + ":" +
            pad(value.getSeconds()) + "." +
            pad(value.getMilliseconds(), 3)
        );
    }
    if (typeof value === "string") {
        return value.replace("T", " ").replace("Z", "");
    }
    return null;
};